import { ibkApi } from '@ibk/shared-config';
export const buildListAddressesQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses`,
    method: 'GET',
});
export const transformListAddressesResponse = (response) => response.result ?? [];
export const buildUpdateAddressMutation = ({ contractId, addressId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/addresses/${addressId}`,
    method: 'PATCH',
    body,
});
export const transformUpdateAddressResponse = (response) => response.result;
export const contractAddressesApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getEmissorContractAddresses: build.query({
            query: buildListAddressesQuery,
            transformResponse: transformListAddressesResponse,
        }),
        updateEmissorContractAddress: build.mutation({
            query: buildUpdateAddressMutation,
            transformResponse: transformUpdateAddressResponse,
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorContractAddressesQuery, useUpdateEmissorContractAddressMutation } = contractAddressesApi;
